export enum SuperAdminRoute {
  ROOT = 'super-admin',
  PROGRAMS = 'programs',
  BANNERS = 'banners',
  POLL_BACKGROUNDS = 'poll-backgrounds',
  PEOPLE = 'people',
  MODERATION = 'moderation',
  DEV_AREA = 'dev-area',
}
